import { defineMessages } from 'react-intl';

export const mfaChallengeMessages = defineMessages({
  verifyTitle: {
    id: 'signIn.mfa.verifyTitle',
    defaultMessage: 'Two-step verification',
  },
  verifyDescription: {
    id: 'signIn.mfa.verifyDescription',
    defaultMessage: 'Enter the 6-digit code from your authenticator app.',
  },
  recoveryDescription: {
    id: 'signIn.mfa.recoveryDescription',
    defaultMessage:
      'Enter one of the recovery codes you saved. It will be used up, and two-step verification will be turned off for your account.',
  },
  enrollTitle: {
    id: 'signIn.mfa.enrollTitle',
    defaultMessage: 'Set up two-step verification',
  },
  enrollDescription: {
    id: 'signIn.mfa.enrollDescription',
    defaultMessage:
      'Admin accounts require a 6-digit code at every sign in. Scan the QR code with an authenticator app, or enter the key manually, then enter the code it generates.',
  },
  codeDigitLabel: {
    id: 'signIn.mfa.codeDigitLabel',
    defaultMessage: 'Digit {position} of {total}',
  },
  confirmButton: {
    id: 'signIn.mfa.confirmButton',
    defaultMessage: 'Confirm',
  },
  continueButton: {
    id: 'signIn.mfa.continueButton',
    defaultMessage: 'Continue',
  },
  useRecoveryCode: {
    id: 'signIn.mfa.useRecoveryCode',
    defaultMessage: 'Lost access to your authenticator app?',
  },
  useCodeInstead: {
    id: 'signIn.mfa.useCodeInstead',
    defaultMessage: 'Enter a code instead',
  },
  backToSignIn: {
    id: 'signIn.mfa.backToSignIn',
    defaultMessage: 'Back to sign in',
  },
  signInRequired: {
    id: 'mfa.signInRequired',
    defaultMessage:
      'Your authenticator is set up. Save these codes, then sign in again to finish.',
  },
  recoveryCodesTitle: {
    id: 'signIn.mfa.recoveryCodesTitle',
    defaultMessage: 'Save your recovery codes',
  },
  recoveryCodesDescription: {
    id: 'signIn.mfa.recoveryCodesDescription',
    defaultMessage:
      'These codes are shown once and never again. Each one can be used once, to turn two-step verification off if you lose access to the app.',
  },
  recoveryCodesSaved: {
    id: 'signIn.mfa.recoveryCodesSaved',
    defaultMessage: 'I have saved these codes somewhere safe',
  },
  wrongCode: {
    id: 'signIn.mfa.wrongCode',
    defaultMessage:
      'Incorrect code. Codes change every 30 seconds — enter the current one.',
  },
  retriesLimit: {
    id: 'signIn.mfa.retriesLimit',
    defaultMessage:
      'Too many incorrect codes. Sign in again to start a new attempt.',
  },
  expired: {
    id: 'signIn.mfa.expired',
    defaultMessage: 'This attempt has expired. Sign in again.',
  },
  unknownError: {
    id: 'signIn.mfa.unknownError',
    defaultMessage: 'Something went wrong. Please try again.',
  },
});
